import { apiSlice } from 'store/slices/api/api-slice';
import { UserList, UserListRequest } from 'types/user/user';
import {
    UsersCardDetailsResponse,
    UsersDetailsRequest,
    UsersDetailsResponse,
    UsersListRequest,
    UsersListResponse,
} from 'types/users/users';
import serializeObjectToURI from 'util/serializer';

export const userList = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        userList: builder.query<UserList[], UserListRequest>({
            query: (params) => ({
                url: '/user/user-by-nickname',
                method: 'GET',
                params,
            }),
        }),

        statusList: builder.query<string[], void>({
            query: () => ({
                url: '/status-enum',
                method: 'GET',
            }),
        }),

        /*  usersList: builder.query<UsersListResponse, UsersListRequest>({
            query: (params) => ({
                url: '/user/user-list',
                method: 'GET',
                params,
            }),
        }),*/

        usersList: builder.query<
            UsersListResponse,
            UsersListRequest | undefined
        >({
            query: (data?: UsersListRequest) => ({
                url: data
                    ? serializeObjectToURI(data, `/user/user-list?`)
                    : '/user/user-list',
                method: 'GET',
            }),
        }),

        usersDetails: builder.query<UsersDetailsResponse, UsersDetailsRequest>({
            query: (params) => ({
                url: '/user/user-details',
                method: 'GET',
                params,
            }),
        }),

        usersCardDetails: builder.query<
            UsersCardDetailsResponse,
            UsersDetailsRequest
        >({
            query: (params) => ({
                url: '/user-card/user-card-details',
                method: 'GET',
                params,
            }),
        }),

        userStatus: builder.query<string[], void>({
            query: () => ({
                url: '/user/user-status-enum',
                method: 'GET',
            }),
        }),

        userSystem: builder.query<string[], void>({
            query: () => ({
                url: '/user/user-system-enum',
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useUserListQuery,
    useStatusListQuery,
    useLazyUsersListQuery,
    useUserStatusQuery,
    useUserSystemQuery,
    useUsersDetailsQuery,
    useUsersCardDetailsQuery,
} = userList;
